// extracted by css-extract-rspack-plugin
module.exports =  {"root":"cd150b0108","picture":"b84a012c67","title":"c75c114715","position":"cbc8db2787","borderedImage":"ee7cb564d1","avatar":"cdfaaf089c"};